<template>
  <div class="page_content">
    <div class="topgap" v-if="!embedded">
    </div>

    <b-container fluid>
      <b-row class="page-content-section">
        <div class="left-container">
          <div class="employer-detail-title ace_sec_txt">
            <span class="ic_container">
              <span class="ic ico-employer"></span>
            </span>
            <h1
              class="head_txt module_type_name ace_sec_hd"
              role="heading"
              aria-level="1">
              {{ employer.displayName }}
            </h1>
            <span
              v-if="isBookmarkEnabled"
              class="employer-detail-bookmark ace_sec_txt"
              :class="{ bookmarked: isEmployerBookmarked }"
              :title="isEmployerBookmarked ? 'remove this employer from bookmark' : 'bookmark this employer'"
              role="button"
              tabindex="0"
              @click.stop="toggleEmployerBookmark"
              @keydown.enter.stop="toggleEmployerBookmark">
              <span class="ic8-bookmark3"></span>
            </span>
          </div>
          <div class="details-tabs" role="tablist">
            <button
              type="button"
              class="details-tab"
              :class="{ 'is-active': activeTab === 'details' }"
              role="tab"
              :aria-selected="activeTab === 'details' ? 'true' : 'false'"
              @click="activeTab = 'details'">
              {{ $t('details') }}
            </button>
            <button
              v-if="isResourcesTabEnabled"
              type="button"
              class="details-tab"
              :class="{ 'is-active': activeTab === 'resources' }"
              role="tab"
              :aria-selected="activeTab === 'resources' ? 'true' : 'false'"
              @click="activeTab = 'resources'">
              {{ getResourcesLabel }}
            </button>
            <button
              v-if="isSubOrgTabEnabled"
              type="button"
              class="details-tab"
              :class="{ 'is-active': activeTab === 'schools' }"
              role="tab"
              :aria-selected="activeTab === 'schools' ? 'true' : 'false'"
              @click="activeTab = 'schools'">
              {{ getSubOrgTabLabel }}
            </button>
            <div v-show="isSubOrgTabEnabled && activeTab === 'schools'" class="schools-tab-toolbar">
              <div class="out-of-total-item ace_sec_txt">
                <div>{{ schoolTotal }} {{ getSubOrgTabLabel }}</div>
              </div>
              <div class="number-of-item ace_sec_txt">
                <b-dropdown id="schoolsSizeDropdown" :text="'' + schoolPageSize" :aria-label="$t('numberOfItem')">
                  <template v-for="(option, index) in schoolSizeOptions">
                    <b-dropdown-divider v-if="index > 0" :key="'school-divider-' + option"></b-dropdown-divider>
                    <b-dropdown-item :key="'school-size-' + option" @click="changeSchoolSize(option)">{{ option }} {{ $t('itemPerPage') }}</b-dropdown-item>
                  </template>
                </b-dropdown>
              </div>
              <div class="pagination btn_container pagination_sty3">
                <button type="button" class="btn btn_trans" :disabled="schoolFirstPage" @click="prevSchoolPage" :title="$t('previousPage')" :aria-label="$t('previousPage')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
                <span class="current-page ace_sec_txt">{{ schoolPage + 1 }}</span>
                <button type="button" class="btn btn_trans" :disabled="schoolLastPage" @click="nextSchoolPage" :title="$t('nextPage')" :aria-label="$t('nextPage')"><span class="ic2_arr_next3" aria-hidden="true"></span></button>
              </div>
              <div class="search-box-container">
                <input
                  type="text"
                  class="input-search"
                  :placeholder="$t('typeToNarrowResults')"
                  v-model.trim="schoolSearchTerms"
                  :aria-label="$t('typeToNarrowResults')"
                  @keypress.enter="searchSchools">
                <button class="btn btn_srh" @click="searchSchools" :aria-label="$t('goAria')">
                  <span class="ic_srh ic_search"></span>
                </button>
              </div>
            </div>
            <b-button
              v-show="showEdit && activeTab === 'details'"
              class="status-update-btn"
              @click="goToEdit">
              Edit
            </b-button>
            <div v-show="showEdit && isSubOrgTabEnabled && activeTab === 'schools'" class="schools-tab-actions">
              <b-button
                v-if="isSubOrgUploadEnabled"
                class="status-update-btn"
                @click="goToUploadSubOrg">
                {{ $t('upload') }}
              </b-button>
              <b-button class="status-update-btn" @click="goToCreateSubOrg">
                {{ $t('add') }}
              </b-button>
            </div>
          </div>
          <div class="details-tab-content">
          <div v-show="activeTab === 'details'">
          <div class="employer-header-row" :class="{ 'has-logo': employer.logo }">
            <div class="employer-logo" v-if="employer.logo">
              <img :src="employer.logo" :alt="employer.title || ''"/>
            </div>
            <a
              href="#"
              class="employer-meta-item employer-job-count"
              @click.prevent="goToJobBoard">
              <div class="icon_container">
                <span class="icon-briefcase" aria-hidden="true"></span>
              </div>
              <span class="ace_sec_txt job-count-link">{{ jobPostedCount }} {{ $t('jobs') }}</span>
            </a>
            <div class="employer-meta-item">
              <div class="icon_container">
                <span class="ic2_url" aria-hidden="true"></span>
              </div>
              <div class="ace_sec_txt">
                <b-link
                  v-if="employer.uri"
                  :href="employer.uri"
                  :title="employer.displayName || employer.title"
                  target="_blank">
                  {{ employer.displayName || employer.title }}
                </b-link>
                <span v-else>{{ $t('na') }}</span>
              </div>
            </div>
            <div class="employer-meta-item">
              <div class="icon_container">
                <span class="icon-location" aria-hidden="true"></span>
              </div>
              <div class="ace_sec_txt">{{ city }}</div>
            </div>
            <div class="employer-meta-item">
              <div class="icon_container">
                <span class="icon-map" aria-hidden="true"></span>
              </div>
              <div class="ace_sec_txt">{{ state }}</div>
            </div>
            <div class="employer-meta-item">
              <div class="icon_container">
                <span class="icon-phone" aria-hidden="true"></span>
              </div>
              <div class="ace_sec_txt">{{ phone }}</div>
            </div>
            <div class="employer-meta-item">
              <div class="icon_container">
                <span class="icon-phone" aria-hidden="true"></span>
              </div>
              <div class="ace_sec_txt">{{ fax }}</div>
            </div>
            <div class="employer-meta-item">
              <div class="icon_container">
                <span class="icon-user" aria-hidden="true"></span>
              </div>
              <div class="ace_sec_txt">{{ supportName }}</div>
            </div>
            <div class="employer-meta-item">
              <div class="icon_container">
                <span class="icon-mail" aria-hidden="true"></span>
              </div>
              <div class="ace_sec_txt address-text">{{ email }}</div>
            </div>
            <div class="employer-meta-item">
              <div class="icon_container">
                <span class="ico-map" aria-hidden="true"></span>
              </div>
              <div class="ace_sec_txt">{{ region }}</div>
            </div>
            <div class="employer-meta-item employer-address-item">
              <div class="icon_container">
                <span class="icon-location" aria-hidden="true"></span>
              </div>
              <div class="ace_sec_txt address-text">{{ address }}</div>
            </div>
          </div>
          <div class="employer-meta-row description_row ace_sec_txt">
            <div class="employer-meta-item employer-description-item">
              <div class="icon_container">
                <span class="ic ic2_description" aria-hidden="true"></span>
              </div>
              <div>
                <h2 class="head_txt module_type_name ace_sec_hd">
                  {{ $t('description') }} 
                </h2>
              </div>
            </div>
          </div>
          <div class="job-meta-row description_row ace_sec_txt">
            <div class="employer-meta-item employer-description-item">
              <div class="job-description" v-if="employer.description" v-html="employer.description"></div>
              <div v-else class="no-description">{{ $t('noDescriptionForEmployer') }}</div>
            </div>
          </div>
          </div>
          <div v-show="isResourcesTabEnabled && activeTab === 'resources'"></div>
          <div v-if="isSubOrgTabEnabled && activeTab === 'schools'">
            <sub-org-list
              :parent-id="employerUuid"
              :show-edit="showEdit"
              :embedded="embedded"
              :search="schoolAppliedSearch"
              :page="schoolPage"
              :page-size="schoolPageSize"
              @paging="onSchoolPaging">
            </sub-org-list>
          </div>
          </div>
        </div>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import '../../../assets/module/css/job/jobHomepage.min.css'
  import { mapState, mapActions } from 'vuex'
  import { PACKAGE } from '../../../package_constants'
  import SubOrgList from './SubOrgList'
  import employerSettingsFlags from '../employerSettingsFlags'

  export default {
    name: 'employerDetails',
    mixins: [employerSettingsFlags],
    components: {
      SubOrgList
    },
    props: {
      uuid: {
        type: String,
        default: ''
      },
      embedded: {
        type: Boolean,
        default: false
      },
      jobPosted: {
        default: null
      }
    },
    data () {
      return {
        employer: {},
        activeTab: 'details',
        schoolSearchTerms: '',
        schoolAppliedSearch: '',
        schoolPage: 0,
        schoolPageSize: 10,
        schoolSizeOptions: [10, 20, 50],
        schoolTotal: 0,
        schoolFirstPage: true,
        schoolLastPage: true
      }
    },
    mounted () {
      this.setTabFromRoute()
      this.loadEmployer()
      this.loadAllBookmarks()
    },
    methods: {
      ...mapActions([
        'loadEmployerOrgInfo',
        'storeSelectedFactes',
        'loadCreateBookmarks',
        'loadDeleteBookmark',
        'loadAllBookmarks'
      ]),
      loadEmployer () {
        if (!this.uuid) {
          return
        }
        this.loadEmployerOrgInfo(this.uuid).then(res => {
          this.employer = res || {}
        })
      },
      goToEdit () {
        let employerId = this.uuid || (this.employer && this.employer.uuid)
        if (!employerId) {
          return
        }
        this.$router.push({ name: 'employerDetailsEdit', params: { uuid: employerId } })
      },
      goToCreateSubOrg () {
        let employerId = this.uuid || (this.employer && this.employer.uuid)
        if (!employerId) {
          return
        }
        this.$router.push({ name: 'subOrgCreate', params: { uuid: employerId } })
      },
      goToUploadSubOrg () {
        let employerId = this.uuid || (this.employer && this.employer.uuid)
        if (!employerId || !this.isSubOrgUploadEnabled) {
          return
        }
        this.$router.push({ name: 'subOrgUpload', params: { uuid: employerId } })
      },
      searchSchools () {
        this.schoolAppliedSearch = this.schoolSearchTerms
        this.schoolPage = 0
      },
      changeSchoolSize (option) {
        this.schoolPageSize = option
        this.schoolPage = 0
      },
      prevSchoolPage () {
        if (this.schoolFirstPage) {
          return
        }
        this.schoolPage -= 1
      },
      nextSchoolPage () {
        if (this.schoolLastPage) {
          return
        }
        this.schoolPage += 1
      },
      onSchoolPaging (meta) {
        this.schoolTotal = (meta && meta.total) || 0
        this.schoolFirstPage = !meta || meta.firstPage
        this.schoolLastPage = !meta || meta.lastPage
        let totalPages = Math.ceil(this.schoolTotal / this.schoolPageSize)
        if (totalPages < 1) {
          totalPages = 1
        }
        if (this.schoolPage > totalPages - 1) {
          this.schoolPage = totalPages - 1
        }
      },
      setTabFromRoute () {
        let tab = this.$route && this.$route.query && this.$route.query.tab
        if (tab === 'schools' && this.isSubOrgTabEnabled) {
          this.activeTab = 'schools'
          return
        }
        if (tab === 'resources' && this.isResourcesTabEnabled) {
          this.activeTab = 'resources'
          return
        }
        if (tab === 'details' || tab === 'schools' || tab === 'resources') {
          this.activeTab = 'details'
        }
      },
      goToJobBoard () {
        let employerName = this.employer.displayName
        if (!employerName) {
          return
        }
        this.storeSelectedFactes({key: 'employerSelected', value: [employerName]})
        this.$router.push({
          name: 'jobBoard',
          query: {
            employer: employerName,
            _: Date.now()
          }
        })
      },
      async toggleEmployerBookmark () {
        if (!this.employer || !this.employer.uuid) {
          return
        }
        if (this.isEmployerBookmarked) {
          await this.loadDeleteBookmark(this.currentBookmark.uuid)
          this.notifySuccess('Successfully deleted bookmark \'' + this.employer.title + '\'')
        } else {
          const bookmark = {
            'source': 'explore',
            'entityType': 'employer',
            'entityTitle': this.employer.title,
            'entityUuid': this.employer.uuid,
            'institutionId': localStorage.getItem('institutionId'),
            'userId': localStorage.getItem('userid')
          }
          const response = await this.loadCreateBookmarks(bookmark)
          const message = (response ? 'Successfully bookmarked \'' : 'Unable to bookmark \'') + this.employer.title + '\''
          if (response) {
            this.notifySuccess(message)
          } else {
            this.notifyFailure(message)
          }
        }
        await this.loadAllBookmarks()
      },
      isFlagEnabledEnabled (featureTitle, flagTitle) {
        let feature
 = this.enabledFeatures && this.enabledFeatures[featureTitle]
        if (feature && feature.enabled) {
          let flags = feature.flags || []
          for (let i = 0; i < flags.length; i++) {
            let flag = flags[i]
            if (flag.title === flagTitle) {
              return flag.enabled
            }
          }
        }
        return false
      },
      notifySuccess (text) {
        return this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: text
        })
      },
      notifyFailure (text) {
        return this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: text
        })
      }
    },
    computed: {
      ...mapState({
        'bookmarks': state => state.explore.bookmarks,
        'permission': state => state.user.permission
      }),
      isEmployerAdminLogin () {
        if (this.permission && this.permission.userPermission && this.permission.userPermission.employerAdminHomeView) {
          return true
        }
        let role = localStorage.getItem('userrole') || ''
        return role === 'Employer Admin' || role.toLowerCase() === 'employer admin'
      },
      showEdit () {
        return this.isEmployerAdminLogin && !this.embedded
      },
      isResourcesTabEnabled () {
        return this.isFlagEnabledEnabled('Employer Settings', 'Resources tab')
      },
      getResourcesLabel(){
        return this.getLabelFor('Employer Settings', 'Resources tab', this.$t('resources'))
      },
      isSubOrgTabEnabled () {
          return this.isFlagEnabledEnabled('Employer Settings', 'Sub Organization tab')
      },
      isSubOrgUploadEnabled () {
        return this.isFlagEnabledEnabled('Employer Settings', 'Allow upload sub organization')
      },
      employerUuid () {
        return this.uuid || (this.employer && this.employer.uuid) || ''
      },
      isBookmarkEnabled () {
        let bookmarkFeature = this.enabledFeatures && this.enabledFeatures[PACKAGE.FEATURE_IDS.BOOKMARK_FEATURE_ID]
        return !!(bookmarkFeature && bookmarkFeature.enabled)
      },
      currentBookmark () {
        if (!this.employer || !this.employer.uuid || !this.bookmarks || !this.bookmarks.length) {
          return null
        }
        let found = this.bookmarks.find((bookmark) => {
          return bookmark.entityUuid === this.employer.uuid && bookmark.entityType === 'employer'
        })
        return found || null
      },
      isEmployerBookmarked () {
        return !!this.currentBookmark
      },
      supportName () {
        return this.employer.employerSupportName || this.$t('na')
      },
      phone () {
        return this.employer.employerPhone || this.$t('na')
      },
      fax () {
        return this.employer.employerFax || this.$t('na')
      },
      region () {
        return this.employer.region? 'Region'+this.employer.region: this.$t('na')
      },
      email () {
        return this.employer.employerSupportEmail || this.$t('na')
      },
      city () {
        return this.employer.city || this.$t('na')
      },
      state () {
        return this.employer.state || this.$t('na')
      },
      address () {
        return this.employer.address || this.$t('na')
      },
      jobPostedCount () {
        let count = this.jobPosted
        if (count === undefined || count === null || count === '') {
          count = this.employer.jobPosted
        }
        if (count === undefined || count === null || count === '') {
          return 0
        }
        return count
      }
    },
    watch: {
      uuid () {
        this.loadEmployer()
      },
      '$route.query.tab' () {
        this.setTabFromRoute()
      }
    }
  }
</script>

<style scoped>
    .page-content-section .left-container {
      float: none;
      width: 100%;
      max-width: 100%;
      margin-top: 0;
    }





    .employer-detail-bookmark {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      margin-left: 10px;
      height: 28px;
      cursor: pointer;
      font-size: 22px;
      line-height: 28px;
      color: rgb(160, 160, 160);
    }

    .employer-detail-bookmark .ic8-bookmark3 {
      display: block;
      line-height: 28px;
      color: inherit;
    }

    .employer-detail-bookmark.bookmarked,
    .employer-detail-bookmark.bookmarked .ic8-bookmark3 {
      color: #F08C03;
    }

    .details-tabs {
      display: flex;
      align-items: center;
      gap: 12px;
    }

    .details-tab {
      height: 36px;
      padding: 0 16px;
      border: 2px solid transparent;
      border-radius: 6px;
      background: #ececec;
      color: #4a4a4a;
      font-size: 15px;
      font-weight: 400;
      cursor: pointer;
      box-shadow: none;
      line-height: 32px;
    }

    .details-tab.is-active {
      border-color: rgb(21, 115, 25);
      background: #e4e4e4;
      color: #4a4a4a;
      font-weight: 400;
    }

    .details-tab:hover,
    .details-tab:focus,
    .details-tab:active {
      outline: none;
      box-shadow: none;
      background: #ececec;
      color: #4a4a4a;
    }

    .details-tab.is-active:hover,
    .details-tab.is-active:focus,
    .details-tab.is-active:active {
      background: #e4e4e4;
      border-color: rgb(21, 115, 25);
      color: #4a4a4a;
    }

    .status-update-btn {
      margin-left: auto;
      flex-shrink: 0;
    }

    .schools-tab-toolbar {
      margin-left: auto;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: flex-end;
      gap: 8px;
      min-width: 0;
      flex: 1 1 auto;
    }

    .schools-tab-toolbar .out-of-total-item {
      white-space: nowrap;
      font-size: 1rem;
      font-weight: 400;
    }

    .schools-tab-toolbar .number-of-item >>> .dropdown-toggle {
      height: 32px;
      padding: 0 12px;
      background-color: #8f8f8f;
      border: none;
      color: #000;
    }

    .schools-tab-toolbar .pagination {
      display: flex;
      align-items: center;
      margin-top: 0;
      padding-top: 0;
    }



    .schools-tab-toolbar .search-box-container {
      display: flex;
      align-items: center;
    }

    .schools-tab-toolbar .search-box-container .input-search {
      width: 180px;
      max-width: 100%;
    }

    .schools-tab-actions {
      display: flex;
      align-items: center;
      gap: 8px;
      flex-shrink: 0;
    }

    .schools-tab-actions .status-update-btn {
      margin-left: 0;
    }

    .employer-header-row {
      display: grid;
      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
      column-gap: 0;
      row-gap: 18px;
      align-items: center;
      width: auto;
      min-width: 0;
      margin-left: 30px;
      margin-bottom: 16px;
    }

    .employer-header-row.has-logo {
      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) auto;
    }

    .employer-logo {
      grid-column: 3;
      grid-row: 1 / 5;
      align-self: start;
      margin: 0 0 0 24px;
    }

    .employer-header-row.has-logo .employer-address-item {
      grid-column: 2 / 4;
    }

    .employer-meta-row {
      display: grid;
      grid-template-columns: 25% 75%;
      column-gap: 0;
      align-items: center;
      width: 100%;
      margin-top: 10px;
      margin-bottom: 25px;
      margin-left:30px;
    }

    .employer-meta-item .address-text {
      white-space: nowrap;
      overflow: visible;
    }

    .employer-job-count {
      cursor: pointer;
      text-decoration: none;
    }

    .employer-job-count .icon-briefcase,
    .employer-job-count .job-count-link {
      color: #0080ca;
    }

    .employer-job-count .job-count-link {
      text-decoration: underline;
    }

    .employer-job-count:hover .icon-briefcase,
    .employer-job-count:hover .job-count-link,
    .employer-job-count:focus .icon-briefcase,
    .employer-job-count:focus .job-count-link {
      color: #005f96;
    }

    .employer-logo img {
      max-height: 80px;
      max-width: 240px;
      width: auto;
      height: auto;
    }

    .description_row {
      display: flex;
      grid-template-columns: none;
      min-height: 24px;
      margin-top: 16px;
      margin-bottom: 0;
    }

    .description_row .head_txt {
      width: auto;
      max-width: none;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-left: 0;
      margin-right: 0;
      margin-bottom: 0;
      font-size: 18px;
      font-weight: 600;
      line-height: 28px;
      white-space: nowrap;
    }

    .employer-description-item {
      width: 100%;
      white-space: normal;
    }

    .job-description {
      width: 100%;
      display: block;
      white-space: pre-wrap;
      word-wrap: break-word;
      margin-top: 0;
      margin-bottom: 24px;
      padding-left: 4em;
      line-height: 1.5;
    }

    .job-description >>> * {
      line-height: 1.5;
    }

    .ico-employer {
      color:#000;
      margin-right: 6px;
    }
    .topgap {
      margin-top: 6px;
    }
    .no-description {
      margin-bottom: 24px;
      padding-left: 4em;
      line-height: 1.5;
    }








</style>



// WEBPACK FOOTER //
// src/app/job/components/EmployerDetails.vue